module.exports = __webpack_public_path__ + "media/panico.a7d675ba.mp3";